import React from 'react';

import EntityDropDownFilterContainerComponent from 'components/entityViewer/entitiesDropDownFilter/EntityDropDownFilterContainer';
import { PartnerCatalogFilterConfigArray } from 'components/fbm/components/partnerCatalog/PartnerCatalogFilterConfig';

/**
 * Catalog filter bar matching partner purchase-order filter UX.
 *
 * @param {Object} props
 * @param {Object} [props.initialValues={}]
 * @param {(nextFilters: Object) => void} [props.onChange]
 */
function PartnerCatalogFilters({ initialValues = {}, onChange }) {
    return (
        <EntityDropDownFilterContainerComponent
            title="Catalog Filters"
            buttonLabel="Catalog Filters"
            filterConfigs={PartnerCatalogFilterConfigArray}
            initialValues={initialValues}
            onChange={onChange}
            autoApply
        />
    );
}

export { PartnerCatalogFilters };
